module.exports = __webpack_public_path__ + "static/1cd6b162630612cf7ae8a7a3b872e9fe093c786402319d6984d8be1c8fd82f5c-d1d060dbdaf3815ba39e04bdf6ad5f39.png";